<script lang="ts">
const __DsBlock = {
	hidden: true,
	icon: 'mdi:button-pointer',
	category: 'basic',
	interactive: true,
	events: [
		{
			name: 'click',
			payload: [],
		},
	],
	options: [
		{
			name: 'label',
			label: '$t:blocks.common.props.label',
		},
		{
			name: 'color',
			label: '$t:blocks.common.props.color',
			block: BuiltinBlockIds.InputSemanticColor,
		},
		{
			name: 'variant',
			label: '$t:blocks.common.props.variant',
			type: 'enum',
			values: ['solid', 'outline', 'soft', 'subtle', 'ghost', 'link'],
		},
		{
			name: 'size',
			label: '$t:blocks.common.props.size',
			type: 'enum',
			values: BLOCK_CONTROL_SIZE_OPTIONS,
		},
		{
			name: 'leadingIcon',
			label: '$t:blocks.common.props.leading_icon',
			block: BuiltinBlockIds.InputIcon,
			nullable: true,
		},
		{
			name: 'trailingIcon',
			label: '$t:blocks.common.props.trailing_icon',
			block: BuiltinBlockIds.InputIcon,
			nullable: true,
		},
		{
			name: 'block',
			label: '$t:blocks.common.props.block',
		},
		{
			kind: FormSchemaKind.Presentational,
			block: BuiltinBlockIds.FormSeparator,
			props: {
				label: '$t:blocks.common.groups.state',
			},
		},
		{
			name: 'loading',
			label: '$t:blocks.common.props.loading',
		},
		{
			name: 'disabled',
			label: '$t:blocks.common.props.disabled',
		},
	],
}
</script>
<script lang="ts" setup>
import type { ButtonProps } from '#layers/ui/public';
import { BuiltinBlockIds } from 'virtual:monospace-builtin-block-ids';
import { defineBlock, FormSchemaKind } from '#layers/block-engine/public';
import { BLOCK_CONTROL_SIZE_OPTIONS } from '#layers/blocks/constants/ui-options';
import { useTranslationUtils } from '#layers/i18n/public';
import { isUrl } from '#layers/ui/public';

interface ButtonBlockProps extends Pick<
	ButtonProps,
'label' | 'color' | 'variant' | 'size' | 'loading' | 'disabled' | 'block'
> {
	leadingIcon?: string;
	trailingIcon?: string;
}

const { label = 'Button' } = defineProps<ButtonBlockProps>();

defineEmits<{
	click: [];
}>();

;

const { translateString } = useTranslationUtils();
</script>

<template>
	<div>
		<DButton
			v-bind="{
				...$props,
				label: translateString(label),
				...leadingIcon && isUrl(leadingIcon) ? {
					avatar: {
						src: leadingIcon,
					},
					leadingIcon: undefined,
				} : {
					leadingIcon,
				},
			}"
			:ui="{
				leadingAvatar: 'rounded-none bg-transparent [&>img]:object-contain',
				base: 'flex',
			}"
			@click="$emit('click')"
		/>
	</div>
</template>
